/**
 * @flow
 */
import React, {Component} from 'react';
import {
  Button, Popover, PopoverHeader, PopoverBody
} from 'reactstrap';
import { translate  } from 'react-i18next';
import { observer } from 'mobx-react';
import Settings from '../../Store/Settings';
import {observable} from "mobx";
import Markdown from 'react-remarkable';

@observer
export class ContactDropdown extends Component {
  @observable contactInfoIsOpen: boolean = false;

  toggleContactInfo = () => {
    this.contactInfoIsOpen = !this.contactInfoIsOpen;
  };


  render () {
    const { t } = this.props;
    const { settings } = Settings;

    return [
        <Button key="contact-btn" block color="primary" className="nav-link text-white" id="contactInfoBtn">
          {t('Contact us')}
        </Button>,
        <Popover  key="contact-popover"
                 trigger="click"
                 placement="bottom-end"
                 isOpen={this.contactInfoIsOpen}
                 target="contactInfoBtn"
                 toggle={this.toggleContactInfo}
                 style={{
                   minWidth: 240
                 }}
        >
          <PopoverHeader>
            <Button close onClick={this.toggleContactInfo}
                style={{
                float: 'right',
                margin: '0 0 0.5em 0.5em'
              }}
            />

            {
              (settings.get('email') || settings.get('phone')) &&
              <p className="mb-0">
                {
                  settings.get('phone') &&
                  <div>
                    <i className="fa fa-phone"></i>&nbsp;<a href={`tel:${settings.get('phone')}`}>{settings.get('phone')}</a>
                  </div>
                }
                {
                  settings.get('email') &&
                  <div>
                    <i className="fa fa-envelope"></i>&nbsp;<a href={`tel:${settings.get('email')}`}>{settings.get('email')}</a>
                  </div>
                }
              </p>
            }
          </PopoverHeader>
          {
            (settings.get('contact_info') || settings.has('locations') && settings.get('locations').length > 0) &&
            <PopoverBody>
              {settings.get('contact_info') && <Markdown>{settings.get('contact_info')}</Markdown>}

              {settings.get('locations').length > 0 && <h6>{t('Locations')}</h6>}
              {settings.get('locations').map((loc, i) => (
                <p key={i}>
                  <strong>{loc.name}</strong>:
                  <br />
                  {loc.phone ? <div><i className="fa fa-phone"></i>&nbsp;<a href={`tel:${loc.phone}`}>{loc.phone}</a></div> : null}
                  {loc.email ? <div><i className="fa fa-envelope"></i>&nbsp;<a href={`mailto:${loc.email}`}>{loc.email}</a></div> : null}
                </p>
              ))}
            </PopoverBody>
          }
        </Popover>
    ];
  }
}

export default translate ()(ContactDropdown);



// WEBPACK FOOTER //
// ./src/App/Layout/Header/ContactDropdown.js